import { getGeocodeCached } from 'shared/services/getGeocodeCached';
import { IApplicationContext } from 'shared/types/applicationContext';
import { loadYmapsApi } from 'shared/utils/ymaps';

function yandexGeocode(request: string, options?: YMaps.IGeocodeOptions) {
  return loadYmapsApi({ require: ['geocode'] })
    .then(ymaps => ymaps.geocode(request, options))
    .then(items => items || []);
}

const geocodeDirect = ({ logger }: IApplicationContext, value: string) =>
  yandexGeocode(value)
    .then(result => {
      return result.geoObjects.toArray().map(geoObject => {
        return {
          text: geoObject.properties.get('text') as string,
          name: geoObject.properties.get('name') as string,
          kind: geoObject.properties.get('metaDataProperty.GeocoderMetaData.kind') as YMaps.TGeoKind,
          coordinates: (geoObject.geometry && geoObject.geometry.getCoordinates()) || [0, 0],
          boundedBy: geoObject.properties.get('boundedBy') as [YMaps.TCoord, YMaps.TCoord],
        };
      });
    })
    .catch(() => {
      logger.warning(`Failed to geocode using 'geocode' for: ${value}`);
    });

const geocodeCached = (context: IApplicationContext, value: string) =>
  getGeocodeCached(context, { request: value }).catch(err => {
    context.logger.warning(`Failed to geocode using 'geocodeCached' for: ${value}`);

    throw err;
  });

export const geocode = (context: IApplicationContext, value: string) =>
  geocodeCached(context, value).catch(() => geocodeDirect(context, value));
